module.exports = __webpack_public_path__ + "img/mobile_register_hogc_logo.82ca3a4.png";